import { Tool } from './Tool';

export class LaserTool extends Tool {
  public title = 'TOOLBAR_LASER';

  public icon = 'icon-laser_pointer';
}

export const laserTool = new LaserTool();
